import React from 'react';
import '../Component/skills.css'
import html from '../image/html.png'
import css from '../image/css3-logo.png'
import js from '../image/js.png'
import react from '../image/react js.png'
import typescript from '../image/typescript.png'
import redux from '../image/redux.png'
import node from '../image/nodejs-1-logo.png'
import express from '../image/express js.png'
import mongodb from '../image/mongodb.png'
import next from '../image/Next.js.png'
import native from '../image/react native.png'
import tail from '../image/tailwind css.png'
import mui from '../image/mui.png'
import fire from '../image/firebase.png'
import bootstrap from '../image/bootstrap.png'
import postgre from '../image/postgre.png'

const Card = ({ imgSrc, text , title }) => {
  return (
    <div className="item-1">
      <div className="card-1">
        <div className="circle-1 circle2"></div>
        <div className="circle-1 circle1"></div>
        <img src={imgSrc} alt="card" />
        <p>{title}</p>
      </div>
      <div className="content-1">
        <p>{text}</p>
      </div>
    </div>
  );
};

const Skills = () => {
  return (
    <>
    <div className='title-1' id='skills'>
    <h1 data-aos="fade-down">Skills<span id="line-1"></span></h1>
    </div>
    <div className="container-1" data-aos="fade-down">
      <Card
        imgSrc={html}
        text="HyperText Markup Language for creating web pages."
        title="HTML"
      />
      <Card
        imgSrc={css}
        text=" Cascading Style Sheets for styling HTML elements."
        title="CSS"
      />
      <Card
        imgSrc={js}
        text="Programming language for creating dynamic web content."
        title="Javascript"
      />
        <Card
          imgSrc={typescript}
          text="Typed superset of JavaScript for building scalable applications."
          title="Typescript"
        />
      <Card
        imgSrc={react}
        text="JavaScript library for building user interfaces."
        title="React JS"
      />
        <Card
          imgSrc={next}
          text="React framework for server-rendered applications."
          title="NEXT JS"
        />
        <Card
          imgSrc={native}
          text="Framework for building native mobile apps using React."
          title="React Native"
        />
      <Card
        imgSrc={redux}
        text="Redux library for managing application state."
        title="Redux"
      />
      <Card
        imgSrc={node}
        text="JavaScript runtime for building server-side applications."
        title="Node JS"
      />
      <Card
        imgSrc={express}
        text="Node.js framework for building web applications."
        title="Express JS"
      />
      <Card
        imgSrc={mongodb}
        text="Mongo Database is flexibility, scalability data efficiently."
        title="MongoDB"
      />
          <Card
            imgSrc={postgre}
            text="Open-source relational database robust features and reliability."
            title="PostgreSQL"
          />
        <Card
          imgSrc={fire}
          text="Google's mobile and web application development platform."
          title="Firebase"
        />
      <Card
        imgSrc={tail}
        text="CSS framework for designing custom and responsive web interfaces."
        title="Tailwind CSS"
      />
      <Card
        imgSrc={mui}
        text="React components library for building intuitive, beautiful user interfaces."
        title="Material UI"
      />
      <Card
        imgSrc={bootstrap}
        text="Front-end framework for creating sleek and responsive websites,."
        title="Bootstrap"
      />
    </div>
    </>
  );
};

export default Skills;
